
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { AppUtilityService } from '../../../core/services/app-utility.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsTabsDragDropService } from '../../../core/services/lms-tabs-drag-drop.service';
import { LmsTerminalStatusSubmenuService } from '../../../core/services/lms-terminal-status-submenu.service';
import { TerminalConfigService } from '../../shared/services/terminal-config.service';
import { Tab } from './../../../core/model/tab.model';
import { TerminalStatus } from './../../../core/model/terminal-status.model';
import { TerminalStatusService } from './../../shared/services/terminal-status.service';


/**
 * @export
 * @class LmsTerminalStatusListComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-terminal-bound-status-list',
  templateUrl: './lms-terminal-bound-status-list.component.html',
  styleUrls: ['./lms-terminal-bound-status-list.component.scss'],
})
export class LmsTerminalBoundStatusListComponent implements OnInit, AfterViewInit, OnDestroy {
  terminalStateOpenList;
  terminalStatusSubscription: any;
  @Input() tab: Tab;
  collpaseHeader = '';
  @Input() allData: TerminalStatus;
  @Input() onTermEachSlideHeight: number;
  @Output() onLocoSelect: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Output() hideContextMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() heightCalculate: EventEmitter<boolean> = new EventEmitter<boolean>();
  statusKey: Array<string>;
  droppable = {};
  counter: number;
  terminalConfigData: any;
  terminalStatusLocosMapping = {
    'inReadyTrackList': {
      clickedLocoPage: 0,
      page: 0,
    },
    'onTerminalList': {
      clickedLocoPage: 0,
      page: 0,
    },
    'atServiceCentreList': {
      clickedLocoPage: 0,
      page: 0,
    },
    'onPitList': {
      clickedLocoPage: 0,
      page: 0,
    },
    'inShopList': {
      clickedLocoPage: 0,
      page: 0,
    },
    'storedAtTerminalList': {
      clickedLocoPage: 0,
      page: 0,
    },
    'yardAndLocalList': {
      clickedLocoPage: 0,
      page: 0,
    }


  };

  firstVisibleData = {
    'inReadyTrackList': {
      firstVisible: 0,
    },
    'onTerminalList': {
      firstVisible: 0,
    },
    'atServiceCentreList': {
      firstVisible: 0,
    },
    'onPitList': {
      firstVisible: 0,
    },
    'inShopList': {
      firstVisible: 0,
    },
    'storedAtTerminalList': {
      firstVisible: 0,
    },
    'yardAndLocalList': {
      firstVisible: 0,
    }
  };
  private dragOverSubscription: any;
  private dragEndSubscription;
  constructor(private lmsTabsDragDropService: LmsTabsDragDropService,
    private changeDetectorRef: ChangeDetectorRef,
    private lmsLoaderService: LmsLoaderService,
    private terminalConfig: TerminalConfigService,
    private terminalStatusService: TerminalStatusService,
    private appUtilityService: AppUtilityService,
    private lmsTerminalStatusSubmenuService: LmsTerminalStatusSubmenuService) {
    this.terminalConfigData = this.terminalConfig.terminalConfigData;
    this.dragOverSubscription = this.lmsTabsDragDropService.over$.pipe(
      debounceTime(60))
      .subscribe(data => {
        if (data.dropElement.type !== 'onTerminalList' && (data.dragElement.type === 'OUTBOUND' || data.dragElement.type === 'INBOUND')) {
          this.droppable = { [data.dropElement.type]: false };
        }
      });
    this.dragEndSubscription = this.lmsTabsDragDropService.end$.pipe(
      debounceTime(60))
      .subscribe(data => {
        this.droppable = { [data.dropElement.type]: true };
      });
  }

  ngOnInit() {
    this.setInitThings();
  }

  /**
   * in starting get clicked row
   * @private
   * @memberof LmsTerminalBoundStatusListComponent
   */
  private setInitThings() {
    this.getClickedRow(this.terminalStatusService.expandHeaderName);
  }

  ngAfterViewInit() { }

  /**
   * update loco carousel according to header name
   * @param {any} $event
   * @memberof LmsTerminalBoundStatusListComponent
   */
  updateLocosCarousel($event) {
    this.terminalStatusService.expandHeaderName = $event.statusHeader;
    this.terminalStatusLocosMapping[$event.statusHeader].page = $event.page;
    this.getClickedRow($event.statusHeader);
  }
  /**
   * Shows locomotive context menu
   * @param {any} event
   * @memberOf LmsTerminalStatusListComponent
   */
  public showLocoContextMenu(event) {
    this.onLocoSelect.emit(event);
  }

  /**
   * emit method to hide context menu
   * @param {any} event
   * @memberof LmsTerminalBoundStatusListComponent
   */
  public hideContextMenuPanel(event) {
    this.hideContextMenu.emit(event);
  }

  /**
   * on which row we cliked
   * by this methid we calculated
   * @param {any} statusHeader
   * @memberof LmsTerminalBoundStatusListComponent
   */
  getClickedRow(statusHeader) {
    if (statusHeader) {
      const element = this.allData.terminalStatusLocos[statusHeader];
      for (let index = 0; index < element.length; index++) {
        if (this.allData.terminalStatusLocos[statusHeader][index].clicked || this.allData.terminalStatusLocos[statusHeader][index].isLocated) {
          this.firstVisibleData[statusHeader].firstVisible = index;
          break;
        }
      }
    } else {
      if (this.allData.isLocated && this.allData.isLocatedKey) {
        const element = this.allData.terminalStatusLocos[this.allData.isLocatedKey];
        for (let index = 0; index < element.length; index++) {
          if (this.allData.terminalStatusLocos[this.allData.isLocatedKey][index].isLocated) {
            this.firstVisibleData[this.allData.isLocatedKey].firstVisible = index;
            break;
          }
        }
      }
    }
  }

  /**
   * emit to calculate height of page
   * @param {any} event
   * @memberof LmsTerminalBoundStatusListComponent
   */
  heightCalculateEmit(event) {
    this.heightCalculate.emit(event);
  }

  /**to calculate page heigth according
   * to terminal status data we use this method
   **/
  getHeight(key) {
    let returnValue = 0;
    if (key) {
      if (this.lmsTerminalStatusSubmenuService && this.lmsTerminalStatusSubmenuService.terminalStatusList) {
        for (let i = 0; i < this.lmsTerminalStatusSubmenuService.terminalStatusList.length; i++) {
          const item = this.lmsTerminalStatusSubmenuService.terminalStatusList[i];
          if (item.value === key) {
            returnValue = item.height;
            break;
          }
        }
      }
    }
    return returnValue;
  }

  /**
     * This adds resize event
     * @param {any} e
     * @memberOf LmsViewportPagingDirective
     */
  @HostListener('window:resize', ['$event'])
  onResize(e) {
    this.setInitThings();
  }

  /**
   * Lifecycle hook for clean up
   * @memberOf LmsTerminalStatusListComponent
   */
  ngOnDestroy() {
    this.dragOverSubscription.unsubscribe();
    this.dragEndSubscription.unsubscribe();
  }
}
